module.exports = __webpack_public_path__ + "src/assets/menu-images/Mastercard Symbol - PNG/mc_brandcenter_READ-ME_200928.pdf";